import React from 'react';
import Select from 'react-select';

const defaultOptionsValue = {username: '', darkMode: false, unlockedAreas: []};
var areas = [
    "Kandarin",
    "Asgarnia",
    "Desert",
    "Fremennik",
    "Kourend",
    "Morytania",
    "Tirannwn",
    "Wilderness",
];
const mapOptions = (a) => ({value: a, label: a});
export function OptionsPanel(props){
    const {onChange, value} = props;
    const {username, darkMode, unlockedAreas} = value;
    const optionChange = (key, val) => {
        let newValue = {...value, [key]: val};
        onChange(newValue, key);
    }
    
    return <div style={{display: 'flex', flexDirection: 'column'}}>
        <div className="form-group">
            <label htmlFor="username-input">Username</label>
            <input id="username-input" className="form-control" value={username} onChange={(e) => optionChange('username', e.target.value)}/>
        </div>
        <div className="form-group">
            <label htmlFor="unlocked-areas-input">Unlocked areas</label>
            <Select 
                className="ms"
                classNamePrefix="ms"
                id="unlocked-areas-input"
                isMulti 
                value={unlockedAreas?.map(mapOptions) || []} 
                onChange={(v) => optionChange('unlockedAreas', v.map(x => x.label))}
                options={areas.map(mapOptions)}/>
        </div>
        <div className="form-group">
            <label htmlFor="dark-mode-input">Dark mode</label>
            <input type="checkbox" id="dark-mode-input" checked={darkMode} onChange={(e) => optionChange('darkMode', e.target.checked)}/>
        </div>
    </div>
}
const defaultFilterValue = {}
export function FilterPanel(props){
    const {value, onChange, areaNames, skillNames, diffNames} = props;
    const {name, desc, area, diff, complete, skill} = value;
    const filterChange = (key, val) => {
        const newVal = {...value, [key]: val};
        onChange(newVal, key);
    }
    return <div>
        <div className="form-group">
            <label htmlFor="name-filter">Name</label>
            <input id="name-filter" className="form-control" value={name} onChange={(e) => filterChange('name', e.target.value)}/>
        </div>
        <div className="form-group">
            <label htmlFor="desc-filter">Description</label>
            <input id="desc-filter" className="form-control" value={desc} onChange={(e) => filterChange('desc', e.target.value)}/>
        </div>
        <div className="form-group">
            <label htmlFor="area-filter">Area</label>
            <Select
                className="ms"
                classNamePrefix="ms"
                id="area-filter"
                isMulti
                value={area?.map(mapOptions) || []}
                onChange={(e) => filterChange('area', e.map(x => x.label))}
                options={[...areaNames,"Unlocked"].map(mapOptions)}/> 
        </div>
        <div className="form-group">
            <label htmlFor="diff-filter">Difficulty</label>
            <Select
                className="ms"
                classNamePrefix="ms"
                id="diff-filter"
                isMulti
                value={diff?.map(mapOptions) || []}
                onChange={(e) => filterChange('diff', e.map(x => x.label))}
                options={diffNames.map(mapOptions)}/> 
        </div>
        <div className="form-group">
            <label htmlFor="skills-filter">Skills</label>
            <Select
                className="ms"
                classNamePrefix="ms"
                id="skills-filter"
                isMulti
                value={skill?.map(mapOptions) || []}
                onChange={(e) => filterChange('skill', e.map(x => x.label))}
                options={skillNames.map(mapOptions)}/> 
        </div>
        <div className="form-group">
            <label htmlFor="complete-filter">Complete</label>
            <Select 
                className="ms"
                classNamePrefix="ms"
                id="complete-filter"
                value={complete === undefined ? ({value: "", label: 'None'}) : (complete ? ({value: "true", label: 'Yes'}) : ({value: "false", label: 'No'}))} 
                onChange={(e) => {filterChange('complete', e.value === "" ? undefined : (e.value === "true"))}}
                options={[{value: "", label: 'None'}, {value: "true", label: 'Yes'}, {value: "false", label: 'No'}]}>
            </Select>
        </div>
    </div>
}